import * as Sentry from '@sentry/node';
import axios from 'axios';
import camelcaseKeys from 'camelcase-keys';
import { withIronSession } from 'next-iron-session';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useIdleTimer } from 'react-idle-timer';
import { useDispatch, useSelector } from 'react-redux';
import BookingIndicators from '../components/BookingIndicators';
import BookingPayForPerformance from '../components/BookingPayForPerformance';
import BookingSchedule from '../components/BookingSchedule';
import BookingStickyFooter from '../components/BookingStickyFooter';
import BookTopHero from '../components/BookTopHero';
import Head from '../components/head';
import Layout from '../components/Layout';
import OpenGraphDescription from '../components/OpenGraphDescription';
import OpenGraphTitle from '../components/OpenGraphTitle';
import Section from '../components/Section';
import SwooptyBg from '../components/SwooptyBg';
import { FranchiseeProvider } from '../context/Franchisee';
import defaultFranchisee from '../context/Franchisee/defaultFranchisee.json';
import { FranchiseeState } from '../context/Franchisee/franchisee.types';
import { LeadProvider } from '../context/Lead';
import { LeadState } from '../context/Lead/lead.types';
import {
  setCookieData,
  setFranchiseID,
  setVonigoLoading,
  setVonigoStoreFlag,
} from '../features/user/userSlice';
import db from '../SDKs/firebase/firebase';
import Gataware from '../SDKs/Gataware';
import leadConfig from '../sessions/lead';
interface ScheduleProps {
  watchedVideo: boolean;
  franchisee: FranchiseeState;
  lead: LeadState;
}

export const getServerSideProps = withIronSession(async ({ req, res }) => {
  try {
    const leadId = req.session.get('leadId');
    const franchiseeId = req.session.get('franchiseeId');

    const lead = await Gataware.lead.checkIfLeadExists({ leadId });
    // await console.log({ lead });

    const { watchedVideo } = await lead;

    const locationsResponseData = await Gataware.getLocations({
      ids: [franchiseeId],
    }).then((result) => JSON.parse(result.data));

    const franchisees = await locationsResponseData.data.map((franchisee) =>
      camelcaseKeys(franchisee)
    );

    const franchisee: FranchiseeState = await franchisees[0];

    if (
      franchisee?.teamCount &&
      franchisee?.teamCount !== null &&
      franchisee?.teamCount < 1
    ) {
      res.setHeader('location', '/pre-open/');
      res.statusCode = 303;
      return res.end();
    }
    return {
      props: {
        watchedVideo,
        franchisee,
        lead,
      },
    };
  } catch (e) {
    // res.setHeader('location', '/book/');
    // res.statusCode = 303;
    // res.end();

    return {
      props: {
        watchedVideo: false,
        franchisee: defaultFranchisee,
      },
    };
  }
}, leadConfig);

const Schedule: React.FC<ScheduleProps> = ({
  watchedVideo,
  franchisee,
  lead,
}: ScheduleProps) => {
  const [customerExists, setCustomerExists] = useState<boolean>(true);
  const dispatch = useDispatch();
  const router = useRouter();

  useEffect(() => {
    if (!lead?.email) return;
    axios
      .post('/api/check-if-customer-exists/', { email: lead.email })
      .then((res) => {
        if (res.status === 200) {
          setCustomerExists(res.data.data.has_completed_appointments)
          console.log('Anything')
          console.log('Does the customer exist?', customerExists)
        } else {
          setCustomerExists(false)
        }
      }).catch(err => {
        console.log('In the catch of check if customer exists')
        Sentry.captureException(err)
      });
  }, [lead?.email]);


  useEffect(() => {
    console.log('Customer exists?', customerExists)
  }, [customerExists])

  // dashboard idle detection
  const handleOnActive = () => {
    try {
      const userStatusDatabaseRef = db.ref(`/online/${lead.id}`);

      userStatusDatabaseRef.update({
        leadID: lead.id,
      });
    } catch (error) {
      console.log(error);
    }
  };

  useIdleTimer({
    timeout: 3000,
    onActive: handleOnActive,
  });

  useEffect(() => {
    if (!lead?.id) {
      router.push(`/book`);
    }
  }, [lead?.id]);

  return (
    <FranchiseeProvider franchiseeValue={franchisee}>
      <LeadProvider>
        <Layout booking alternateFooter={true}>
          <Head
            slug='schedule'
            title='Schedule | Two Maids '
            description='Schedule Your Cleaning with Two Maids .'
          />
          <OpenGraphTitle title='Schedule | Two Maids ' />

          <OpenGraphDescription>
            {/* Add Schedule description here */}
            Schedule Your Cleaning with Two Maids .
          </OpenGraphDescription>
          <BookTopHero
            page={'schedule'}
            title={`Schedule Your Cleaning`}
            subheading={`Use our easy, no-hassle pricing feature and instantly book your cleaning!`}
          />
          <div className='top-background-dots'></div>

          <Section className='schedule-container-reskin'>
            <Row className='justify-content-center'>
              <Col xs={12} lg={10} xl={9}>
                <BookingSchedule />
              </Col>
            </Row>
          </Section>
          <BookingStickyFooter />
        </Layout>
      </LeadProvider>
    </FranchiseeProvider>
  );
};

export default Schedule;
